import * as react_components from "../reactcomponent.js"
import * as utility from "../services.js"
import * as propertyTypes from "../property_types.js"
import React from "react";

interface TabProps {
    uid: any;
    values: any;
    queryParameter: any;
    onTextChange(propertyName, value): any;
    context: utility.IContextProps;
    rootPropertyPath: any;
    extendedUid: string;
    metadataSettings: TabControlState;
    settings: any;
}


export class ReactTabControl extends React.Component<TabProps, { selectedIndex: number, loadMissingData?: boolean }>{
    handleTabClick = (tabIndex, e) => {
        e.preventDefault();
        if (tabIndex != this.state.selectedIndex) {
            this.setState({ selectedIndex: tabIndex, loadMissingData: true });
        }
    }

    constructor(props) {
        super(props);
        this.state = { selectedIndex: props.settings.selectedIndex || 0 };
    }

    handleTextChange = (name, value) => {
        this.props.onTextChange(name, value);
    }

    renderComponent = (component, index) => {
        const newPropertyPath: [any] = this.props.rootPropertyPath;
        newPropertyPath.push('tabs')
        newPropertyPath.push(this.props.settings.selectedIndex)
        newPropertyPath.push('content')
        newPropertyPath.push(index);

        var compObj = utility.getComponentBySettings(component, this.props.values, this, this.props.queryParameter, this.props.context, newPropertyPath, this.props.extendedUid);

        return compObj;
    }

    createTab = (tab, i) => {
        const className = 'statisticTabControl ' + (i == this.state.selectedIndex ? 'active' : '');
        const icon = tab.icon ? <i className={tab.icon.fontawesomeIcon} ></i> : null;
        return (
            <button key={tab.uid}
                className={className}
                onClick={(e) => this.handleTabClick(i, e)}>
                {icon}
                <react_components.TruncatedLabel>{tab.header}</react_components.TruncatedLabel>
            </button>)
    }

    render() {
        let i = 0;
        let that = this;
        let content = null;
        let index = 0;
        let tabs;
        let selectedIndex;
        if (Array.isArray(this.props.settings.tabs)) {
            tabs = this.props.settings.tabs.map(function (tab) { return that.createTab(tab, i++) });
            selectedIndex = this.state.selectedIndex;
            const tab = this.props.settings.tabs[selectedIndex || 0];

            if (tab) {
                var tabContent = tab.content;
                if (Array.isArray(tabContent)) {
                    content = tabContent.map(function (component) { return that.renderComponent(component, index++) });
                    content.key = selectedIndex;
                }
            }
        }

        return (<react_components.ReactColumn width={this.props.settings.width} height={this.props.context.fullHeightLayout ? "100%" : null}>
            <div className={"nav-tabs-custom " + this.props.uid} style={{ display: "flex", flexDirection: "column", height: this.props.context.fullHeightLayout ? "100%" : null }}>
                <div>{tabs}</div>
                <ReactTab key={selectedIndex} content={content} loadMissingData={this.state.loadMissingData} context={this.props.context} queryParameter={this.props.queryParameter} ></ReactTab>
            </div>
        </react_components.ReactColumn >)
    }
};

class ReactTab extends React.Component<any, any>{
    constructor(props, context) {
        super(props, context);
        this.state = {};
    }

    componentDidMount() {
        if (this.props.loadMissingData) {
            this.props.context.loadMissingData(this.props.queryParameter);
        }
    }

    render() {
        const style: React.CSSProperties = { overflow: "hidden" };
        if (this.props.context.fullHeightLayout) {
            style.flex = 1;
            style.overflow = "auto";
        }
        return <div className="tab-content" style={style} >
            {this.props.content}
        </div>
    }
}

export class TabControlState extends propertyTypes.BaseComponentProps {
    private labelMetadata = new propertyTypes.TranslatableTextProperty("label", "Label");
    public label: string;

    private selectedIndexMetadata = new propertyTypes.TextProperty("selectedIndex", "Selected index");
    public selectedIndex: string;

    private tabControlMetadata: propertyTypes.BaseProperty[];
    constructor() {
        super();
        const baseMetaData = super.getMetadata();
        this.tabControlMetadata = baseMetaData.concat([this.labelMetadata, this.selectedIndexMetadata]);
    };

    getMetadata(): propertyTypes.BaseProperty[] {
        return this.tabControlMetadata;
    }
}

export class Tab extends propertyTypes.Serializable {
    private nameMetadata = new propertyTypes.TextProperty("name", "Name");
    public name: string;

    private headerMetadata = new propertyTypes.TranslatableTextProperty("header", "Header");
    public header: string;

    private iconMetadata = new propertyTypes.ObjectPropertyExt("icon", "Icon")
        .addStateImplementation("faIcon", TabIcon);
    public icon: string;

    private tabMetadata: propertyTypes.BaseProperty[] = [this.nameMetadata, this.headerMetadata, this.iconMetadata];

    getMetadata(): propertyTypes.BaseProperty[] {
        return this.tabMetadata;
    }
}

export class TabIcon extends propertyTypes.Serializable {

    private fontawesomeIconMetadata = new propertyTypes.TextProperty("fontawesomeIcon", "Font Awesome icon");
    public fontawesomeIcon: string;

    private tabMetadata: propertyTypes.BaseProperty[] = [this.fontawesomeIconMetadata];

    getMetadata(): propertyTypes.BaseProperty[] {
        return this.tabMetadata;
    }
}